import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';
import { Types } from './types';
import { impressaoCrlveSuccess, impressaoCrlveFailure } from './actions';

function* impressaoCrlveRequest(request: { type: string; payload: any }) {
	const { payload } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`servicos/${CHANNEL}/imprimir/crlv`,
		payload,
	);
	if (response.status === 200 || response.status === 201) {
		yield put(impressaoCrlveSuccess(response));
	} else if (response.error) {
		yield put(impressaoCrlveFailure(response.message));
	}
}

export default all([
	takeLatest(Types.IMPRIMIR_CRLVE_REQUEST, impressaoCrlveRequest),
]);
